export default function indexRoutes(scopedRoutes, scopedIndex) {
  scopedRoutes.forEach((route, index) => {
    if (!route.meta) {
      route.meta = {}
    }

    route.meta.index = (scopedIndex || scopedIndex === 0) ? scopedIndex
      : index

    if (route.children) {
      indexRoutes(route.children, route.meta.index)
    }
  })
}



// WEBPACK FOOTER //
// ./src/router/utils/index-routes.js